import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const RequestedMaterialsApi = createApi({
  reducerPath: 'RequestedMaterialsApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.materials.get }),
  tagTypes: ['RequestedMaterialsApi'],
  endpoints: (builder) => ({
    getRequestedMaterials: builder.query({
      query: () => "getMaterialRequest",
      keepUnusedDataFor: 35,
      providesTags: ['RequestedMaterialsApi'],
      invalidatesTags: ['RequestedMaterialsApi'],
    }),
    updateRequestedMaterial: builder.mutation({
      query: (dataMaterials) => {
        const formData = new FormData();
        Object.entries(dataMaterials).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.materials.update+dataMaterials.Id,
          method: 'PUT',
          body: formData,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['RequestedMaterialsApi'], 
    }),  
  }),
 
  keepUnusedDataFor: 1,

});



export const getLastRequestGenIdApi = createApi({
  reducerPath: 'getLastRequestGenIdApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.materials.getLastRequestGenId }),
  endpoints: (builder) => ({
    getLastRequestGenId: builder.query({
      query: () => 'getLastGenIdMaterial',
    })
  })
});

export const { 
  useGetLastRequestGenIdQuery
 } = getLastRequestGenIdApi;


export const {
 useGetRequestedMaterialsQuery,
 useUpdateRequestedMaterialMutation
} = RequestedMaterialsApi;
